import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage from 'hoc/websitePage/websitePage';
import { COMPANY_NU_CONTA } from 'utils/prospectTypes';

import HeroSection from './patterns/HeroSection/HeroSection';
import AdvantagesSection from './patterns/AdvantagesSection/AdvantagesSection';
import CardBannerSection from './patterns/CardBannerSection/CardBannerSection';
import TotalControlSection from './patterns/TotalControlSection/TotalControlSection';
import AutonomySection from './patterns/AutonomySection/AutonomySection';
import BuildTogetherSection from './patterns/BuildTogetherSection/BuildTogetherSection';
import TargetAudienceSection from './patterns/TargetAudienceSection/TargetAudienceSection';

function BusinessAccount({
  registrationButtonLabel,
  onToggleRegistrationForm,
  isRegistrationFormOpen,
}) {
  const { formatMessage } = useContext(NuDsContext);
  const cardsArea = formatMessage({ id: 'cms.businessAccountPage.cardsArea' });

  const cardComponentsMap = {
    AdvantagesSection,
    CardBannerSection,
    AutonomySection,
    TotalControlSection,
    BuildTogetherSection,
    TargetAudienceSection,
  };

  return (
    <>
      <HeroSection />
      {cardsArea.map(({ componentName, id }, index) => {
        const CardComponent = cardComponentsMap[componentName];
        return (
          <CardComponent
            key={id}
            buttonLabel={registrationButtonLabel}
            onButtonClick={onToggleRegistrationForm}
            isRegistrationFormOpen={isRegistrationFormOpen}
            index={index}
          />
        );
      })}
    </>
  );
}

BusinessAccount.propTypes = {
  isRegistrationFormOpen: PropTypes.bool,
  onToggleRegistrationForm: PropTypes.func.isRequired,
  registrationButtonLabel: PropTypes.string.isRequired,
};

BusinessAccount.defaultProps = {
  isRegistrationFormOpen: false,
};

export default websitePage({
  routeKey: 'BUSINESS_ACCOUNT',
  widgetProspectType: COMPANY_NU_CONTA,
})(BusinessAccount);
